import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { generateClientReferenceId } from "~/utils";

type Checkout = {
	hubId: string;
	checkoutId: string;
	checkoutSecret: string | undefined;
	createdAt: number;
};

type CheckoutStore = {
	checkouts: Checkout[];
	removeCheckout: (checkoutId: string) => void;
	getCheckout: (hubId: string) => Checkout;
	setCheckoutSecret: (checkoutId: string, checkoutSecret: string) => void;
	cleanStaleCheckouts: () => void;
};

export const useCheckoutStore = create<CheckoutStore>()(
	persist(
		(set, get) => ({
			checkouts: [],
			getCheckout: (hubId: string) => {
				const checkout = get().checkouts.find((checkout) => checkout.hubId === hubId);
				if (checkout) return checkout;
				const newCheckout: Checkout = {
					hubId: hubId,
					checkoutId: generateClientReferenceId(),
					checkoutSecret: undefined,
					createdAt: Date.now(),
				};
				set((state) => ({ checkouts: [...state.checkouts, newCheckout] }));
				return newCheckout;
			},
			setCheckoutSecret: (checkoutId: string, checkoutSecret: string) =>
				set((state) => ({
					checkouts: state.checkouts.map((checkout) => (checkout.checkoutId === checkoutId ? { ...checkout, checkoutSecret } : checkout)),
				})),
			removeCheckout: (checkoutId) =>
				set((state) => ({ checkouts: state.checkouts.filter((checkout) => checkout.checkoutId !== checkoutId) })),
			cleanStaleCheckouts: () => {
				const THIRTY_MINUTES = 30 * 60 * 1000;
				set((state) => ({
					checkouts: state.checkouts.filter((checkout) => checkout.createdAt && Date.now() - checkout.createdAt < THIRTY_MINUTES),
				}));
			},
		}),
		{
			name: "checkouts",
			storage: createJSONStorage(() => localStorage),
		}
	)
);
